module.exports = __webpack_public_path__ + "img/s1.ca93a1ee.svg";